import type { Data } from '@repo/strapi-types'
import { Fragment } from 'react'
import AppLink from '@/components/elementary/AppLink'

interface SeoNavigationFallbackProps {
	items?: Data.Component<'layout-utilities.navbar-item'>[] | null
	login?: Data.Component<'utilities.link'> | null
	buttons?: Data.Component<'utilities.link'>[] | null
	dropdown?: Data.Component<'layout-utilities.dropdown-item'> | null
}

export function SeoNavigationFallback({
	items,
	login,
	buttons,
	dropdown,
}: SeoNavigationFallbackProps) {
	return (
		<nav className="sr-only" aria-label="Main navigation">
			<ul>
				{Array.isArray(items) &&
					items.map((item) => (
						<li key={item.id}>
							{item.href ? (
								<AppLink href={item.href} openExternalInNewTab={item.newTab ?? false} tabIndex={-1}>
									{item.label}
								</AppLink>
							) : (
								<span>{item.label}</span>
							)}

							{/* Render navbar items as nested links for SEO */}
							{item.columns?.length ? (
								<ul>
									{item.columns.map((column) => (
										<Fragment key={column.id}>
											{column.groups?.map((group) => (
												<li key={group.id}>
													{group.links?.map((link) =>
														link.href ? (
															<AppLink
																key={link.id}
																href={link.href}
																openExternalInNewTab={link.newTab ?? false}
																tabIndex={-1}
															>
																{link.title}
															</AppLink>
														) : null,
													)}
													{group.moreLink?.href && (
														<AppLink
															href={group.moreLink.href}
															openExternalInNewTab={group.moreLink.newTab ?? false}
															tabIndex={-1}
														>
															{group.moreLink.title}
														</AppLink>
													)}
												</li>
											))}
										</Fragment>
									))}
								</ul>
							) : null}
						</li>
					))}

				{/* CTA buttons for SEO */}
				{login?.href && login?.label ? (
					<li>
						<AppLink href={login.href} tabIndex={-1}>
							{login.label}
						</AppLink>
					</li>
				) : null}

				{buttons?.map((primaryButton) =>
					primaryButton.href ? (
						<li key={primaryButton.id}>
							<AppLink href={primaryButton.href} tabIndex={-1}>
								{primaryButton.label}
							</AppLink>
						</li>
					) : null,
				)}

				{dropdown?.links?.map((link) =>
					link.href ? (
						<li key={link.id}>
							<AppLink href={link.href} openExternalInNewTab={link.newTab ?? false} tabIndex={-1}>
								{link.title}
							</AppLink>
						</li>
					) : null,
				)}
			</ul>
		</nav>
	)
}
